import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import {
    Pen2,
    TrashBinMinimalistic,
    Copy,
    TagHorizontal,
} from "@solar-icons/react/ssr";
import { useState } from "react";
import { AddonPopup } from "./AddonForm";
import LineGroupPopup from "@/sheet/LineGroupPopup";
import { store } from "./bidStore";

export default function LineGroupMenu({
    openCopy,
    openDelete,
    anchorEl,
    close,
    lineGroupData,
}) {
    const isRunning = store.showRunning;
    const [addonPopupOpen, setAddonPopupOpen] = useState(false);
    const [lineGroupPopupOpen, setLineGroupPopupOpen] = useState(false);

    const handleEdit = () => {
        setLineGroupPopupOpen(true);
        close();
    };
    const handleDeleteLine = () => {
        openDelete();
    };
    const handleOpenCreateAddonPopup = () => {
        setAddonPopupOpen(true);
        close();
    };
    const copyGroup = () => {
        openCopy();
    };
    return (
        <>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
                <MenuItem onClick={handleEdit}>
                    <ListItemIcon>
                        <Pen2 size={18} />
                    </ListItemIcon>
                    <ListItemText>Batch Edit</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDeleteLine}>
                    <ListItemIcon>
                        <TrashBinMinimalistic size={18} />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
                {!isRunning && (
                    <MenuItem onClick={handleOpenCreateAddonPopup}>
                        <ListItemIcon>
                            <TagHorizontal size={18} />
                        </ListItemIcon>
                        <ListItemText>Create Add-on</ListItemText>
                    </MenuItem>
                )}
                <MenuItem onClick={copyGroup}>
                    <ListItemIcon>
                        <Copy size={18} />
                    </ListItemIcon>
                    <ListItemText>Duplicate</ListItemText>
                </MenuItem>
            </Menu>

            <AddonPopup
                isOpen={addonPopupOpen}
                lineGroupId={lineGroupData?.id}
                close={() => {
                    setAddonPopupOpen(false);
                }}
            />

            {lineGroupData && (
                <LineGroupPopup
                    isOpen={lineGroupPopupOpen}
                    lineGroup={lineGroupData}
                    close={() => {
                        setLineGroupPopupOpen(false);
                    }}
                    popupType={"override"}
                />
            )}
        </>
    );
}
